<tui-elastic-container>
  <div class="grid grid-cols-1 gap-1 sm:grid-cols-2 md:grid-cols-3">
    @if (loading()) {
      @for (skeleton of skeletons(); track $index) {
        <div class="flex flex-col gap-2 p-3" data-testid="skeleton">
          <div class="aspect-4/3 w-full rounded-xl" [tuiSkeleton]="true"></div>
          <div class="h-4 w-2/3 rounded-sm" [tuiSkeleton]="true"></div>
          <div class="h-3 w-1/2 rounded-sm" [tuiSkeleton]="true"></div>
        </div>
      }
    } @else {
      @for (entity of entities(); track entity.id) {
        <pxc-sadm-entity-select
          [attr.data-testid]="'sadm-entity-' + entity.id"
          [selected]="entity.id === selectedId()"
          (selectedChange)="selectedIdChange.emit(entity.id)">
          <pxc-sadm-entity-preview [sadmEntity]="entity" [sadmType]="entity.sadmClient?.sadmType ?? sadmType()" />
        </pxc-sadm-entity-select>
      } @empty {
        @if (emptyTemplate(); as template) {
          <ng-container [ngTemplateOutlet]="template" />
        } @else {
          <pxc-empty-state
            class="col-span-full"
            data-testid="no-entity"
            icon="@tui.clipboard-list"
            [title]="emptyMessage()" />
        }
      }
    }
  </div>
</tui-elastic-container>
